var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.462 5.23A4.23 4.23 0 1 1 1 5.23a4.23 4.23 0 0 1 8.462 0m-.903 4.036a5.23 5.23 0 1 1 .707-.707l2.587 2.587a.5.5 0 0 1-.707.707z",
    clipRule: "evenodd"
  })));
});
const SvgSearchsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjQ2MTU0IDUuMjMwNzdDOS40NjE1NCA3LjU2NzM2IDcuNTY3MzYgOS40NjE1NCA1LjIzMDc3IDkuNDYxNTRDMi44OTQxOCA5LjQ2MTU0IDEgNy41NjczNiAxIDUuMjMwNzdDMSAyLjg5NDE4IDIuODk0MTggMSA1LjIzMDc3IDFDNy41NjczNiAxIDkuNDYxNTQgMi44OTQxOCA5LjQ2MTU0IDUuMjMwNzdaTTguNTU4OTYgOS4yNjYzMUM3LjY1NDY0IDEwLjAxMyA2LjQ5NTA5IDEwLjQ2MTUgNS4yMzA3NyAxMC40NjE1QzIuMzQxOSAxMC40NjE1IDAgOC4xMTk2NCAwIDUuMjMwNzdDMCAyLjM0MTkgMi4zNDE5IDAgNS4yMzA3NyAwQzguMTE5NjQgMCAxMC40NjE1IDIuMzQxOSAxMC40NjE1IDUuMjMwNzdDMTAuNDYxNSA2LjQ5NTIxIDEwLjAxMjkgNy42NTQ4NyA5LjI2NjA5IDguNTU5MjNMMTEuODUzMyAxMS4xNDY0QzEyLjA0ODUgMTEuMzQxNyAxMi4wNDg1IDExLjY1ODIgMTEuODUzMyAxMS44NTM1QzExLjY1OCAxMi4wNDg4IDExLjM0MTQgMTIuMDQ4OCAxMS4xNDYxIDExLjg1MzVMOC41NTg5NiA5LjI2NjMxWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";